import type { JSX } from "solid-js";

export const QUEUE_CONTROL_CLASS = "h-10 w-full rounded-lg border border-gray-700 bg-gray-950 px-3 text-sm text-gray-100 outline-none transition focus:border-cyan-500 focus:ring-2 focus:ring-cyan-500/15";

export function QueueStatusBadge(props: { status: string }) {
  const tone = () => props.status === "completed" || props.status === "enabled"
    ? "border-emerald-800/70 bg-emerald-950/60 text-emerald-300"
    : props.status === "running" || props.status === "leased"
      ? "border-cyan-700/70 bg-cyan-950/60 text-cyan-300"
      : props.status === "failed" || props.status === "interrupted" || props.status === "dead_letter"
        ? "border-red-800/70 bg-red-950/60 text-red-300"
        : props.status === "pending" || props.status === "retry_wait"
          ? "border-amber-800/70 bg-amber-950/50 text-amber-300"
          : "border-gray-700 bg-gray-800/70 text-gray-300";

  return (
    <span class={`inline-flex w-fit shrink-0 items-center rounded-full border px-2.5 py-1 text-[11px] font-semibold leading-none ${tone()}`}>
      {props.status.replaceAll("_", " ")}
    </span>
  );
}

export function QueueField(props: {
  label: string;
  hint?: string;
  children: JSX.Element;
  class?: string;
}) {
  return (
    <label class={`block min-w-0 ${props.class ?? ""}`}>
      <span class="block text-xs font-semibold uppercase tracking-[0.12em] text-gray-500">{props.label}</span>
      <div class="mt-1.5">{props.children}</div>
      {props.hint ? <span class="mt-1.5 block text-xs leading-5 text-gray-600">{props.hint}</span> : null}
    </label>
  );
}

export function QueueMetric(props: {
  label: string;
  value: string | number;
  detail: string;
  tone?: "neutral" | "cyan" | "green" | "amber" | "red";
}) {
  const color = () => props.tone === "cyan"
    ? "text-cyan-300"
    : props.tone === "green"
      ? "text-emerald-300"
      : props.tone === "amber"
        ? "text-amber-300"
        : props.tone === "red"
          ? "text-red-300"
          : "text-gray-100";
  return (
    <div class="rounded-xl border border-gray-800 bg-gray-950/55 p-4 shadow-inner shadow-black/10">
      <div class="text-xs font-semibold uppercase tracking-[0.14em] text-gray-500">{props.label}</div>
      <div class={`mt-2 text-2xl font-semibold tracking-tight ${color()}`}>{props.value}</div>
      <div class="mt-1 text-xs leading-5 text-gray-500">{props.detail}</div>
    </div>
  );
}

export function QueueSectionHeading(props: {
  eyebrow?: string;
  title: string;
  description: string;
  action?: JSX.Element;
}) {
  return (
    <div class="flex flex-wrap items-start justify-between gap-4">
      <div class="min-w-0">
        {props.eyebrow ? <div class="text-xs font-semibold uppercase tracking-[0.16em] text-cyan-500/80">{props.eyebrow}</div> : null}
        <h3 class="mt-1 text-base font-semibold text-gray-100">{props.title}</h3>
        <p class="mt-1 max-w-3xl text-sm leading-6 text-gray-500">{props.description}</p>
      </div>
      {props.action}
    </div>
  );
}
